import { PERMISSIONS } from "@/constants/permissions";

/**
 * Get the default route based on user's permissions
 * Returns the module matching the first permission in the user's array
 */
export function getDefaultRoute(permissionNames: string[] = []): string {
  // Filter out null/undefined/empty values and check for valid permissions
  const validPermissions = (permissionNames || []).filter(
    (p): p is string => p !== null && p !== undefined && p !== ""
  );

  // If user has no valid permissions, redirect to coming soon page
  if (validPermissions.length === 0) {
    return "/dashboards/coming-soon";
  }

  // Map of permissions to dashboard routes
  const routeMap: Array<{ permission: string; route: string }> = [
    { permission: PERMISSIONS.ACTIVE_CHAT, route: "/dashboards/chats" },
    { permission: PERMISSIONS.PREVIOUS_CHAT, route: "/dashboards/history" },
    { permission: PERMISSIONS.REPORT_CONVERSATION_USER, route: "/dashboards/reports/conversations" },
    { permission: PERMISSIONS.REPORT_LIVE_AGENT_ANALYTICS, route: "/dashboards/reports/live-agent-analytics" },
    { permission: PERMISSIONS.REPORT_MODULE_ANALYTICS, route: "/dashboards/reports/module-analytics" },
    { permission: PERMISSIONS.REPORT_PERFORMANCE_MATRICS, route: "/dashboards/reports/performance-metrics" },
    { permission: PERMISSIONS.ROPORT_FEEDBACK_ANALYTICS, route: "/dashboards/reports/feedback-analytics" },
    { permission: PERMISSIONS.REPORT_SENTIMENT_ANALYTICS, route: "/dashboards/reports/sentiment-analytics" },
    { permission: PERMISSIONS.QUEUE_LIST, route: "/dashboards/queues" },
    { permission: PERMISSIONS.AGENT_LIST, route: "/dashboards/agents" },
    { permission: PERMISSIONS.ADMIN_QUEUE_LIST, route: "/dashboards/admin_queues" },
    { permission: PERMISSIONS.ADMIN_USER_LIST, route: "/dashboards/admin_users" },
    { permission: PERMISSIONS.LVE_CHAT, route: "/dashboards/livechat" },
    { permission: PERMISSIONS.HISTORY_LIST, route: "dashboards/history-list" },
    { permission: PERMISSIONS.TICKET_MANAGEMENT, route: "/dashboards/ticketing" },
    { permission: PERMISSIONS.TECH_SUPPORT_TICKET_LIST, route: "/dashboards/ticketing" }
  ];

  // Navigate to the module corresponding to the FIRST permission array item
  for (const userPerm of validPermissions) {
    const match = routeMap.find((item) => item.permission === userPerm);
    if (match) {
      return match.route;
    }
  }

  // Fallback to home if no matching permissions found
  return "/dashboards/home";
}
